import React, { Component, PureComponent, Fragment } from 'react'

import illustrationFail from '../../images/illustration-fail.svg'

const Icon = (IconComponent, CustomProps) => {
  return class extends Component {
    static defaultProps = {
      stroke: 'none',
      addToDimension: true,
      id: '',
      className: '',
    }
    render() {
      const { width, height, ...rest } = this.props
      const { viewBox: cViewBox, ...customRest } = CustomProps
      let viewBox = `0 0 ${width} ${height}`

      if (rest.viewBox && rest.viewBox !== '') {
        viewBox = rest.viewBox
      } else if (cViewBox && cViewBox !== '') {
        viewBox = cViewBox
      }

      if (!rest.color) {
        rest.color = CustomProps.color
      }
      return (
        <svg
          id={rest.id}
          className={rest.className}
          width={rest.addToDimension ? width : null}
          height={rest.addToDimension ? height : null}
          viewBox={viewBox}
          preserveAspectRatio="xMidYMid meet"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <IconComponent {...customRest} {...rest} />
        </svg>
      )
    }
  }
}

class ChevArrowRight extends PureComponent {
  render() {
    return (
      <g
        className="icon-chev icon-chev--right"
        stroke="none"
        strokeWidth="1"
        fill={this.props.color[0]}
        fillRule="evenodd"
      >
        <path d="M13.094 12.438L8.911 8.203a1 1 0 1 1 1.423-1.406l4.877 4.939a1 1 0 0 1 0 1.405l-5 5.062a1 1 0 0 1-1.422-1.406l4.305-4.359z"></path>
      </g>
    )
  }
}

class ChevArrowLeft extends PureComponent {
  render() {
    return (
      <g
        className="icon-chev icon-chev--left"
        stroke="none"
        strokeWidth="1"
        fill={this.props.color[0]}
        fillRule="evenodd"
      >
        <path d="M10.906 12.562l4.183 4.235a1 1 0 1 1-1.423 1.406L8.79 13.264a1 1 0 0 1 0-1.405l5-5.062a1 1 0 0 1 1.422 1.406l-4.305 4.359z"></path>
      </g>
    )
  }
}

class EmptyList extends PureComponent {
  render() {
    return (
      <g
        className="icon-emptylist"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(-163.000000, -26.000000)">
          <g transform="translate(151.000000, 17.000000)">
            <rect x="0" y="0" width="64" height="64"></rect>
            <rect
              stroke={this.props.color[0]}
              strokeWidth="2"
              fill={this.props.color[1]}
              x="13"
              y="10"
              width="38"
              height="45"
              rx="2"
            ></rect>
            <rect
              fill={this.props.color[2]}
              x="20"
              y="29"
              width="24"
              height="2"
              rx="1"
            ></rect>
            <rect
              fill={this.props.color[2]}
              x="20"
              y="33"
              width="24"
              height="2"
              rx="1"
            ></rect>
            <rect
              fill={this.props.color[2]}
              x="20"
              y="37"
              width="24"
              height="2"
              rx="1"
            ></rect>
            <rect
              fill={this.props.color[2]}
              x="36"
              y="47"
              width="8"
              height="2"
              rx="1"
            ></rect>
            <rect
              fill={this.props.color[2]}
              x="36"
              y="43"
              width="8"
              height="2"
              rx="1"
            ></rect>
            <rect
              fill={this.props.color[2]}
              x="20"
              y="19"
              width="8"
              height="2"
              rx="1"
            ></rect>
          </g>
        </g>
      </g>
    )
  }
}

class SpinLoader extends PureComponent {
  static defaultProps = {
    shouldRotate: true,
  }
  render() {
    const { shouldRotate } = this.props
    return (
      <path
        data-testid="spinLoader"
        fill={this.props.color[0]}
        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
      >
        {shouldRotate && (
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            dur="1s"
            from="0 50 50"
            to="360 50 50"
            repeatCount="indefinite"
          />
        )}
      </path>
    )
  }
}

class Success extends PureComponent {
  render() {
    return (
      <Fragment>
        <defs>
          <path
            d="M118.608178,1.79214 C113.702106,1.836765 108.768366,2.086665 103.867648,2.4945375 C98.0066009,2.98095 92.1973184,3.689595 86.5245884,4.574955 C82.2468359,5.2434375 78.0449459,6.0145575 73.9474784,6.8838525 C72.5810609,7.173915 71.2253534,7.47558 69.8830334,7.7888475 C68.5576709,8.09676 67.2448034,8.4171675 65.9453234,8.75007 C61.7648534,9.8166075 57.7137959,11.0036325 53.8108934,12.3352425 C47.5714259,14.46207 41.7094859,16.9548225 36.2795159,19.9589775 C31.9562459,22.349985 27.9060809,25.066755 24.1656134,28.1842575 C21.7924559,30.1602525 19.5451409,32.2986825 17.4379484,34.61115 C16.3642709,35.78925 15.3441434,36.9932325 14.3784584,38.2230975 L14.1580109,38.5051275 C12.8853059,40.1437575 11.7080984,41.8252275 10.6246034,43.548645 C7.74361337,48.1262775 5.53110587,52.9904025 4.03616837,57.9937575 C2.78666837,62.17869 2.04143087,66.4546575 1.84061837,70.716345 C1.68175337,74.072145 1.86203837,77.4163425 2.39664587,80.694495 C2.60727587,81.9877275 2.87413337,83.2711425 3.19543337,84.5402775 C3.46318337,85.60146 3.77288087,86.6519325 4.12095587,87.69348 C5.16339587,90.81366 6.56372837,93.832095 8.32195337,96.70416 C10.6549484,100.514243 13.6234034,104.066393 17.2050059,107.283855 C20.2011284,109.975635 23.6247584,112.434473 27.4455509,114.63627 C32.6309759,117.62436 38.5500359,120.136748 45.0751034,122.155583 C46.8217259,122.696438 48.5853059,123.19356 50.3649509,123.65052 C58.1529059,125.652398 66.1862984,126.88137 74.1375809,127.478453 C81.3284534,128.014845 88.4523884,128.035373 95.3478434,127.561455 C100.384221,127.21338 105.301896,126.60291 110.060706,125.713088 C111.467286,125.448908 112.857801,125.162415 114.235821,124.850933 C115.831611,124.487685 117.409551,124.0932 118.966071,123.663908 C122.913598,122.573273 126.729036,121.26219 130.406136,119.710133 C135.075696,117.737708 139.518561,115.376153 143.716881,112.584413 C148.738086,109.24914 153.413893,105.298043 157.694323,100.7097 C159.342771,98.9434425 160.932313,97.08258 162.458488,95.1306825 L162.493296,95.0860575 C163.653546,93.600045 164.776311,92.06316 165.859806,90.4736175 C167.915233,87.45786 169.767171,84.3474975 171.412941,81.1818 C174.005653,76.192725 176.087856,71.0617425 177.629203,65.9441475 C179.566821,59.5181475 180.651208,53.1207075 180.807396,47.0624175 C180.903786,43.2746475 180.636036,39.6171825 179.992543,36.16053 C179.791731,35.084175 179.554326,34.0283475 179.281221,32.992155 C178.994728,31.9077675 178.667181,30.8456925 178.299471,29.8086075 C177.055326,26.29662 175.344403,23.067555 173.168488,20.1696075 C171.351358,17.75004 169.208466,15.5643075 166.752306,13.6222275 L166.420296,13.3634025 C164.939638,12.2192175 163.345633,11.1624975 161.643636,10.194135 C156.460888,7.2408525 150.263368,5.1167025 143.196553,3.75207 C141.582913,3.4388025 139.923756,3.16659 138.223543,2.9300775 C132.361603,2.1179025 126.286356,1.785 120.153096,1.785 C119.638123,1.785 119.123151,1.7876775 118.608178,1.79214 Z"
            id="icon-success_path-1"
          ></path>
          <path
            d="M177.851817,91.4120571 C177.85104,93.7716868 177.748844,96.1002335 177.547502,98.3923942 C177.024722,104.346159 175.83259,110.052926 174.019962,115.500137 C172.505368,120.05634 170.556636,124.434622 168.208665,128.652424 C166.359743,131.972941 164.264438,135.194379 161.940896,138.327205 C161.024461,139.562195 160.072431,140.783927 159.086897,141.991705 C158.236072,143.033422 157.36012,144.064673 156.459041,145.086155 C153.40961,148.544126 150.077502,151.886272 146.501803,155.100035 C141.604148,159.499249 136.245834,163.66193 130.535045,167.475047 C124.217719,171.689361 117.467653,175.47736 110.449566,178.541808 C108.846329,179.241635 107.230529,179.903087 105.602166,180.521279 C99.5221502,182.832175 93.6068557,184.416729 87.9623735,185.214239 C83.8038692,185.803126 79.7926365,185.965001 75.9663657,185.701257 C71.3918713,185.387277 67.0819075,184.461384 63.0971977,182.969628 C60.0931354,181.845579 57.2726393,180.401967 54.6601381,178.670889 C53.7890717,178.093862 52.9410384,177.486136 52.116736,176.847012 C51.1312026,176.082993 50.1784737,175.276412 49.2627373,174.429363 C46.9391956,172.282435 44.8431922,169.878043 42.994968,167.267122 C40.6469974,163.950792 38.6982656,160.304434 37.1829731,156.43201 C35.3710433,151.799753 34.1789108,146.85212 33.6568294,141.727264 C33.4598403,139.798887 33.3573854,137.845608 33.3518166,135.870365 L33.3518166,135.529706 C33.3560125,134.04022 33.4152377,132.538372 33.5304969,131.025418 C33.7559411,128.054466 34.1886824,125.132356 34.8105736,122.256994 C35.7898253,117.724513 37.2367168,113.309949 39.0786592,108.980509 C41.3931272,103.543067 44.3308823,98.2347063 47.7655919,92.9793731 C49.9146411,89.6923478 52.2584239,86.4262545 54.7704173,83.1741158 C55.5514456,82.1630991 56.3485272,81.1527802 57.1616621,80.1445544 C57.9859644,79.1216762 58.8263201,78.1008912 59.6820312,77.0815017 C62.2470704,74.0261241 64.9489117,70.9840034 67.7673139,67.9746763 C71.5056404,63.9836372 75.4498681,60.045626 79.5623064,56.2443706 C83.0019018,53.0654941 86.5580582,49.9836026 90.2133263,47.0740514 C95.175194,43.1255741 100.317138,39.4917749 105.602166,36.4273268 C107.01695,35.6067915 108.421964,34.839284 109.816508,34.1275952 C115.920254,31.0080261 121.816703,28.9685493 127.438152,28.1459208 C129.28321,27.8742107 131.098519,27.7336125 132.881066,27.7237917 L133.282123,27.7237917 C136.264467,27.7402673 139.15396,28.1247802 141.936382,28.8757507 C145.26849,29.7737344 148.446347,31.1943211 151.439242,33.1005306 C152.322871,33.663602 153.190448,34.2685375 154.041273,34.9139415 C154.854408,35.5314362 155.652188,36.1852131 156.433216,36.8745743 C158.944511,39.0919733 161.288992,41.6791713 163.437343,44.579652 C166.872751,49.2167928 169.810506,54.6542346 172.124276,60.6128838 C173.966916,65.3574757 175.41311,70.4293048 176.392362,75.6937086 C177.014951,79.0344594 177.447692,82.4540542 177.673136,85.9231882 C177.791999,87.7511399 177.851226,89.5634779 177.851817,91.3578715 L177.851817,91.4120571"
            id="icon-success_path-3"
          ></path>
          <linearGradient
            x1="0%"
            y1="0%"
            x2="50%"
            y2="100%"
            id="icon-success_linearGradient-5"
          >
            <stop stopColor={this.props.color[0]} offset="0%"></stop>
            <stop stopColor={this.props.color[1]} offset="97.9133173%"></stop>
            <stop stopColor={this.props.color[2]} offset="100%"></stop>
          </linearGradient>
          <path
            d="M11.955159,61.8476315 L18.0373046,61.8476315 C20.3845147,61.8476315 22.2873046,59.9448417 22.2873046,57.5976315 L22.2873046,0.363392006 L7.70515905,0.363392006 L7.70515905,57.5976315 C7.70515905,59.9448417 9.60794886,61.8476315 11.955159,61.8476315 Z"
            id="icon-success_path-6"
          ></path>
          <linearGradient
            x1="0%"
            y1="0%"
            x2="50%"
            y2="68.3078188%"
            id="icon-success_linearGradient-8"
          >
            <stop stopColor={this.props.color[3]} offset="0%"></stop>
            <stop stopColor={this.props.color[4]} offset="100%"></stop>
          </linearGradient>
          <linearGradient
            x1="11.1475797%"
            y1="0%"
            x2="91.2219862%"
            y2="91.4216423%"
            id="icon-success_linearGradient-9"
          >
            <stop stopColor={this.props.color[0]} offset="0%"></stop>
            <stop stopColor={this.props.color[2]} offset="100%"></stop>
          </linearGradient>
        </defs>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-283.000000, -379.000000)">
            <g transform="translate(241.000000, 379.000000)">
              <g>
                <g transform="translate(42.000000, 0.000000)">
                  <g>
                    <g transform="translate(0.000000, -23.800000)">
                      <rect x="0" y="29.75" width="204" height="153"></rect>
                      <g transform="translate(14.450000, 41.650000)">
                        <mask
                          id="icon-success_mask-2"
                          fill={this.props.color[3]}
                        >
                          <use xlinkHref="#icon-success_path-1"></use>
                        </mask>
                        <use
                          fill={this.props.color[5]}
                          fillRule="evenodd"
                          xlinkHref="#icon-success_path-1"
                        ></use>
                      </g>
                      <mask id="icon-success_mask-4" fill={this.props.color[3]}>
                        <use xlinkHref="#icon-success_path-3"></use>
                      </mask>
                      <use
                        fill={this.props.color[5]}
                        transform="translate(105.601817, 106.773792) rotate(38.000000) translate(-105.601817, -106.773792) "
                        xlinkHref="#icon-success_path-3"
                      ></use>
                      <g mask="url(#icon-success_mask-4)">
                        <g transform="translate(122.198284, 140.358230) rotate(-17.000000) translate(-122.198284, -140.358230) translate(104.348284, 99.983230)">
                          <polygon
                            stroke="none"
                            fill={this.props.color[6]}
                            fillRule="evenodd"
                            points="27.3431706 66.4852303 7.25227064 78.3648331 8.20691575 26.515326 34.8423104 28.2253153"
                          ></polygon>
                          <path
                            d="M34.3266014,77.2973952 C25.697636,81.3391085 15.8450615,81.3505084 7.23290626,77.3289643 L5.43332503,76.4888772 L4.63341104,59.5994979 C4.71126903,56.8880687 6.89217745,54.7290976 9.91448299,54.8141586 L29.393136,55.3596013 C31.5492714,55.4192317 33.6036606,57.6974637 33.5266874,60.4088929 L34.3266014,77.2973952 Z"
                            stroke="none"
                            fill="url(#icon-success_linearGradient-5)"
                            fillRule="evenodd"
                          ></path>
                          <mask
                            id="icon-success_mask-7"
                            fill={this.props.color[3]}
                          >
                            <use xlinkHref="#icon-success_path-6"></use>
                          </mask>
                          <use
                            stroke="none"
                            fill={this.props.color[7]}
                            fillRule="evenodd"
                            xlinkHref="#icon-success_path-6"
                          ></use>
                          <polygon
                            stroke="none"
                            fill={this.props.color[8]}
                            fillRule="evenodd"
                            mask="url(#icon-success_mask-7)"
                            points="5.21521902 -7.95674387 5.1 8.85862081 22.2737937 22.4144406 22.0487575 -8.5"
                          ></polygon>
                          <path
                            d="M34.1749436,29.4431785 L27.3915664,33.3252927 C26.6138713,33.7698899 25.6202972,33.5059377 25.171729,32.7351272 L14.4706794,14.3645803 C12.3693984,10.7560644 13.616011,6.14347778 17.2558719,4.05992156 L18.8563845,3.14441958 C19.6323101,2.69982236 20.6267689,2.96377456 21.0753371,3.73458513 L34.7694955,27.2421153 C35.2189485,28.0129259 34.9526388,28.9985813 34.1749436,29.4431785"
                            stroke="none"
                            fill={this.props.color[9]}
                            fillRule="evenodd"
                          ></path>
                          <path
                            d="M14.8107576,51.7684384 L14.8107576,25.5582481 C14.9337379,24.5401468 14.6178822,23.4781996 13.8339938,22.7021275 L7.27180403,16.1962758 C5.91548249,14.8519611 3.69652982,14.8519611 2.34109303,16.1962758 L1.83943986,16.694365 C1.13075521,17.396776 0.801628263,18.3315702 0.834364008,19.2575952 C0.831709758,19.2961795 0.82197751,19.3321331 0.82197751,19.3707175 L0.82197751,47.6399103 C0.82197751,48.249368 1.16083671,48.7799032 1.65718138,49.0701629 C1.71911387,49.143824 1.77042937,49.2236235 1.83943986,49.292023 L8.40251436,55.7969978 C9.75795115,57.1404356 12.1202333,57.146574 13.3314559,55.7969978 C14.5426784,54.4474216 14.8107576,51.8929607 14.8107576,51.7684384"
                            stroke="none"
                            fill={this.props.color[6]}
                            fillRule="evenodd"
                          ></path>
                        </g>
                      </g>
                      <g transform="translate(97.069215, 73.574351) rotate(-12.000000) translate(-97.069215, -73.574351) translate(39.694215, 37.874351)">
                        <path
                          d="M102.984258,62.7620217 C106.868752,62.589718 109.912228,59.2691554 109.739784,55.3950574 L107.802134,11.755754 C107.629675,7.88192507 104.302592,4.84292503 100.418097,5.01522876 L11.4374056,8.95344784 C7.55393778,9.12514412 4.50974976,12.4462843 4.68218481,16.3195959 L6.62060402,59.9589508 C6.79305773,63.8332689 10.1192182,66.8720114 14.0040961,66.7009827 L102.984258,62.7620217 Z M14.1918091,70.9468353 C7.96388585,71.2212003 2.65168167,66.3681385 2.37479932,60.1477428 L0.436380743,16.5084022 C0.159468615,10.2882811 5.02241533,4.98291632 11.2495877,4.70759993 L100.229973,0.769394431 C106.457353,0.493167838 111.771022,5.3467405 112.047939,11.5669849 L113.98559,55.2063026 C114.262486,61.4270112 109.400549,66.7315946 103.172401,67.0078552 L14.1918091,70.9468353 Z"
                          fill={this.props.color[10]}
                          fillRule="nonzero"
                        ></path>
                        <path
                          d="M102.984258,62.7620217 C106.868752,62.589718 109.912228,59.2691554 109.739784,55.3950574 L107.802134,11.755754 C107.629675,7.88192507 104.302592,4.84292503 100.418097,5.01522876 L11.4374056,8.95344784 C7.55393778,9.12514412 4.50974976,12.4462843 4.68218481,16.3195959 L6.62060402,59.9589508 C6.79305773,63.8332689 10.1192182,66.8720114 14.0040961,66.7009827 L102.984258,62.7620217 Z"
                          fill="url(#icon-success_linearGradient-8)"
                          fillRule="nonzero"
                        ></path>
                        <g transform="translate(57.810814, 36.112652) rotate(-3.000000) translate(-57.810814, -36.112652) translate(31.035814, 15.712652)">
                          <path
                            d="M40.85508,2.37570526 L13.406064,28.2507789 C10.552206,30.9407158 10.414404,35.4401684 13.096902,38.3004632 L13.313958,38.5323789 C15.99717,41.3926737 20.485374,41.5315368 23.339232,38.8416 L50.787534,12.9665263 C53.641392,10.2773053 53.77848,5.77642105 51.095982,2.91612632 L50.880354,2.68564211 C49.484484,1.19751579 47.599524,0.445936842 45.710994,0.445936842 C43.968834,0.445936842 42.223818,1.08513684 40.85508,2.37570526"
                            fill={this.props.color[2]}
                          ></path>
                          <path
                            d="M2.686782,16.3600842 L2.456874,16.5776842 C-0.39627,19.2676211 -0.534072,23.7670737 2.148426,26.6280842 L13.313958,38.5323789 C15.99717,41.3926737 20.485374,41.5315368 23.339232,38.8416 L23.569854,38.624 C26.422998,35.9340632 26.5608,31.4346105 23.877588,28.5736 L12.712056,16.6700211 C11.3169,15.1818947 9.43194,14.4303158 7.544124,14.4303158 C5.801964,14.4303158 4.056234,15.0695158 2.686782,16.3600842"
                            fill="url(#icon-success_linearGradient-9)"
                          ></path>
                        </g>
                      </g>
                    </g>
                    <rect
                      stroke={this.props.color[11]}
                      fill={this.props.color[12]}
                      opacity="0"
                      x="0.5"
                      y="0.5"
                      width="203"
                      height="152"
                    ></rect>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </Fragment>
    )
  }
}

class Leave extends PureComponent {
  render() {
    return (
      <g className="icon-leave">
        <path
          fill={this.props.color[0]}
          d="M49.66,123.49H11.42c-.66,0-1.33,0-2,0a2.16,2.16,0,0,1-2.23-2.22A2.33,2.33,0,0,1,9,118.65c14.86-4.1,29.07-10.05,43.56-15.21a23,23,0,0,1,3.53-1.21c3.33-.6,4.25-1.28,4.33-5.75.1-5.67,0-11.33,0-17V27.75c0-4.77-.28-5.12-4.8-6.77Q35,13.47,14.43,5.88C12.7,5.24,10.1,5,10.61,2.15s3.08-2,4.89-2C39.07.1,62.65.27,86.22,0,92.67,0,96.39,4,96.39,10.18c0,9.42.06,18.83.08,28.24,0,13.58-.14,27.16.16,40.73.25,11.49.21,23,.3,34.47,0,6.47-3.36,9.87-9.79,9.87ZM28,5l0,.48L59.35,17c3.7,1.35,5.7,4,5.71,7.88q0,36.75,0,73.49a7.87,7.87,0,0,1-.61,3.41,9,9,0,0,1-5.9,4.9c-7.49,2.49-14.89,5.29-22.32,8-3,1.08-6,2.21-8.93,3.32.39.53.68.61,1,.61q29.63,0,59.24,0c3.22,0,4.55-1.4,4.52-4.63-.12-11-.06-22-.3-33-.32-15-.14-30-.19-45,0-8.5,0-17-.08-25.5,0-4.42-1.12-5.46-5.45-5.47H28Z"
        />
        <path
          fill={this.props.color[0]}
          d="M10.25,55.26H43a16.87,16.87,0,0,1,2.25.05c1.56.21,2.77,1,2.65,2.72S46.58,60.18,45,60.17c-8.34,0-16.67,0-25,0-3.17,0-6.33,0-9.5,0-.47,0-1.1-.17-1.3.42s.35.88.72,1.18c2.31,1.91,4.59,3.84,7,5.69,1.51,1.17,2.38,2.59,1.1,4.23s-2.85.77-4.14-.29c-4.22-3.51-8.45-7-12.62-10.59a3.1,3.1,0,0,1,0-5C5.32,52.24,9.4,48.7,13.48,45.15c.37-.33.83-.56,1.22-.86a2.25,2.25,0,0,1,3.34.37,2.28,2.28,0,0,1-.3,3.36c-1.89,1.75-3.87,3.4-5.82,5.1C11.32,53.64,10.52,54,10.25,55.26Z"
        />
      </g>
    )
  }
}

class Clock extends PureComponent {
  render() {
    return (
      <g className="icon-clock">
        <path
          fill={this.props.color[0]}
          d="M103.1,62C103,75.4,98.21,87,89.2,96.79c-1.23,1.34-1.3,2.14-.09,3.51,2.26,2.54,4.31,5.28,6.44,7.94a5.66,5.66,0,0,1,.56.82c.72,1.22.78,2.42-.46,3.32s-2.24.17-3-.77c-2.33-2.82-4.7-5.62-6.87-8.56-1.1-1.48-2-1.36-3.26-.39a49,49,0,0,1-33.7,10,48.55,48.55,0,0,1-27.71-10.75c-1.56-1.26-2.35-1.22-3.56.36-2.42,3.17-5,6.18-7.61,9.24-.87,1-1.93,1.73-3.24.77S5.55,110,6.5,108.81c2.64-3.21,5.28-6.42,8-9.56,1-1.2,1.23-2,0-3.34Q-1,78.23,2,54.8C5,32,24.51,13.2,47.79,11.37c14.85-1.16,27.69,3.3,38.7,13.22A50.25,50.25,0,0,1,103.1,62Zm-4.43.18a46.48,46.48,0,1,0-93-.27C5.46,87.33,26.56,108.27,52,108.39,77.8,108.51,98.87,87.49,98.67,62.16Z"
        />
        <path
          fill={this.props.color[0]}
          d="M0,21.07C-.51,10.37,8.46,2.42,18.13.44c5.37-1.1,10.4,0,15.3,2,2.64,1.12,2.74,2.94.29,4.87q-9.49,7.47-19,14.9L5.91,29.18C3.6,31,2.29,30.65,1.22,27.89A15.5,15.5,0,0,1,0,21.07Zm4.07,0a13,13,0,0,0,.14,1.89c.19,1.07.55,1.71,1.78.74,7.13-5.68,14.31-11.31,21.46-17,.36-.29.83-.78.81-1.15,0-.52-.71-.56-1.2-.67a20.14,20.14,0,0,0-9.36.06C9.8,7,4.15,13.42,4.11,21Z"
        />
        <path
          fill={this.props.color[0]}
          d="M104.51,19.78a23.21,23.21,0,0,1-1.36,8.47c-.84,2.38-2.28,2.71-4.36,1q-6-5-12-10.1C82.13,15.2,77.48,11.3,72.91,7.31c-2.52-2.2-2.2-3.85.83-5.12,11.12-4.69,23-.65,28.7,9.84A18.05,18.05,0,0,1,104.51,19.78Zm-4.37.94c0-10-10.94-18.34-20.66-15.82-.49.13-1.07.19-1.24.7s.34.87.72,1.19L98.15,23.11c.42.37.83.95,1.49.66s.43-1,.49-1.55A15,15,0,0,0,100.14,20.72Z"
        />
        <path
          fill={this.props.color[0]}
          d="M10.06,61.69A42.21,42.21,0,0,1,94.47,62C94.39,86,76,104.14,52.21,104.15S10.13,85.89,10.06,61.69ZM52.44,24.24c-21-.56-38.17,16.68-38.2,37.57a38,38,0,1,0,76,.12C90.41,42.19,73.67,23.74,52.44,24.24Z"
        />
        <path
          fill={this.props.color[0]}
          d="M50.12,39.34c0-3.49,0-7,0-10.48,0-1.47.31-2.83,2-2.86s2.37,1.3,2.37,2.89c0,6.91,0,13.81,0,20.72a2.27,2.27,0,0,0,1.63,2.59,10.43,10.43,0,0,1,6.1,13.27,10.25,10.25,0,0,1-13,6.53c-2.37-.81-3.79-.44-5.38,1.37-2.08,2.37-4.43,4.51-6.67,6.73-.86.85-1.77,1.7-3,.52a2.21,2.21,0,0,1,0-3.5c2.57-2.6,5.13-5.22,7.76-7.76a2.49,2.49,0,0,0,.67-3.25,10.39,10.39,0,0,1,5.83-14,2.32,2.32,0,0,0,1.72-2.55C50.07,46.17,50.12,42.76,50.12,39.34ZM46.05,62a6.25,6.25,0,1,0,12.49,0,6.12,6.12,0,0,0-6.41-6.19A5.92,5.92,0,0,0,46.05,62Z"
        />
      </g>
    )
  }
}

class Globe extends PureComponent {
  render() {
    return (
      <g className="icon-globe">
        <path
          fill={this.props.color[0]}
          d="M64.6,0c34.8,0,63.67,29.38,63.57,64.86-.09,34.54-28,64.51-64.13,64.32C27.17,129-.15,98.61,0,64.18A64.63,64.63,0,0,1,64.6,0ZM46.87,6.86a4.57,4.57,0,0,0-2.41.44A60.07,60.07,0,0,0,18.62,25a57.82,57.82,0,0,0-8.45,12.89C8.84,40.59,9,40.74,11.91,40.74c4.75,0,9.49-.12,14.23.06,2.19.09,3.09-.69,3.57-2.73a76,76,0,0,1,7.37-18.72c2.54-4.73,6.11-8.65,9.76-12.52A1,1,0,0,0,47,6.77s0-.09,0-.13Zm19,57.61c0,5.91.06,11.82,0,17.73,0,1.89.44,2.65,2.5,2.63,8.49-.11,17-.08,25.47,0,1.7,0,2.29-.63,2.56-2.24a108.78,108.78,0,0,0,0-36c-.27-1.61-.86-2.26-2.56-2.24-8.49.07-17,.09-25.47,0-2.06,0-2.54.74-2.5,2.64C66,52.82,65.91,58.65,65.91,64.47Zm-3.94,0c0-6,0-12,0-18,0-1.62-.48-2.17-2.13-2.16q-12.85.09-25.72,0c-1.54,0-2.14.49-2.4,2.07a108.41,108.41,0,0,0,0,36.21c.29,1.74,1,2.16,2.59,2.15,8.4-.06,16.81-.09,25.21,0,2.06,0,2.51-.7,2.47-2.59C61.9,76.33,62,70.42,62,64.52ZM17.86,84.78c2.66,0,5.33-.1,8,0,2,.1,2.22-.79,1.94-2.41a103.45,103.45,0,0,1,0-35.71c.31-1.74-.21-2.36-2-2.33-5.32.1-10.65.09-16,0a2.53,2.53,0,0,0-2.91,2,60.23,60.23,0,0,0,0,36.5,2.37,2.37,0,0,0,2.72,1.92C12.36,84.71,15.11,84.78,17.86,84.78Zm92.81-40.37h-7.75c-2.79,0-3,.23-2.47,3a92.35,92.35,0,0,1,1.37,14.37,100.31,100.31,0,0,1-1.39,19.88c-.55,2.92-.32,3.08,2.69,3.08,5.08,0,10.16,0,15.25,0a2.47,2.47,0,0,0,2.84-2,61.55,61.55,0,0,0,.1-36.06c-.5-1.7-1.27-2.47-3.15-2.34C115.67,44.54,113.17,44.41,110.67,44.41ZM65.91,22.31c0,5.33,0,10.66,0,16,0,1.57.39,2.21,2.09,2.2,8.33-.07,16.66,0,25,0,1.53,0,2-.27,1.59-2A61.23,61.23,0,0,0,82.46,13.82,26.77,26.77,0,0,0,68.82,4.58c-2.51-.68-2.9-.37-2.91,2.24C65.9,12,65.91,17.14,65.91,22.31Zm0,84.27c0,5.32.1,10.64,0,16-.06,2.37.9,2.69,2.83,2.15a26.89,26.89,0,0,0,13-8.45c6.54-7.39,10.45-16.09,12.9-25.55.45-1.77-.13-2-1.61-2-8.32,0-16.64.06-25,0-1.66,0-2.14.55-2.12,2.16C66,96.1,65.91,101.34,65.91,106.58ZM62,107.1c0-5.42,0-10.83,0-16.25,0-1.62-.5-2.16-2.14-2.15-8.17.07-16.33,0-24.49,0-1.58,0-2.35.25-1.81,2.12,2.42,8.45,5.6,16.53,11.22,23.46,3.79,4.67,8.21,8.49,14.11,10.27,2.69.81,3.07.51,3.07-2.22Q62,114.72,62,107.1Zm0-84.77c0-5.24-.09-10.49,0-15.73.05-2.21-.78-2.58-2.67-2A25.28,25.28,0,0,0,49,10.4C40.73,18.11,36.46,28,33.48,38.65c-.45,1.62.38,1.83,1.69,1.83,8.24,0,16.48,0,24.71,0,1.68,0,2.14-.6,2.11-2.19C61.92,33,62,27.66,62,22.33Zm19.85,100c.38-.1.78-.18,1.15-.31a59.37,59.37,0,0,0,23.28-14.45,60.25,60.25,0,0,0,12-17c.73-1.54.59-2.19-1.36-2.15-5.16.1-10.32.07-15.47,0-1.54,0-2.34.31-2.76,2A84.93,84.93,0,0,1,93.49,105,65.3,65.3,0,0,1,81.82,122.35ZM81.67,7.06a88.59,88.59,0,0,1,7.14,8.72c4.72,7.07,7.69,14.89,9.87,23a2.17,2.17,0,0,0,2.55,2c5-.07,10,0,15,0,3,0,3,0,1.66-2.85A60.67,60.67,0,0,0,95.7,13.17,42.35,42.35,0,0,0,81.67,7.06ZM19.18,88.73c-2.42,0-4.83,0-7.25,0-2.86,0-3,.18-1.73,2.69a60.61,60.61,0,0,0,33.66,30.3c.55.21,1.27,1,1.79.3s-.27-1.33-.77-1.83a46.23,46.23,0,0,1-6.23-7.78,78.07,78.07,0,0,1-9.16-21.74c-.41-1.54-1.08-2-2.57-2C24.34,88.79,21.76,88.73,19.18,88.73Z"
        />
      </g>
    )
  }
}

class Notice extends PureComponent {
  render() {
    return (
      <g className="icon-notice">
        <path
          fill="none"
          stroke={this.props.color[0]}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          d="M24.5,3.6l16.9,30.6c0.9,1.6,0.3,3.6-1.3,4.5c-0.5,0.3-1,0.4-1.6,0.4H4.7c-1.8,0-3.3-1.5-3.3-3.3
        c0-0.6,0.1-1.1,0.4-1.6L18.7,3.6c0.9-1.6,2.9-2.2,4.5-1.3C23.7,2.6,24.2,3.1,24.5,3.6z"
        />
        <path
          fill="none"
          stroke={this.props.color[0]}
          strokeMiterlimit="10"
          d="M20.6,11.1h1.8c0.9,0,1.7,0.7,1.7,1.7v12.7c0,0.9-0.7,1.7-1.7,1.7h-1.8c-0.9,0-1.7-0.7-1.7-1.7V12.8
        C19,11.9,19.7,11.1,20.6,11.1z"
        />
        <path
          fill="none"
          stroke={this.props.color[0]}
          strokeMiterlimit="10"
          d="M20.6,29h1.8c0.9,0,1.7,0.7,1.7,1.7v2c0,0.9-0.7,1.7-1.7,1.7h-1.8c-0.9,0-1.7-0.7-1.7-1.7v-2
        C19,29.8,19.7,29,20.6,29z"
        />
      </g>
    )
  }
}

class Calendar extends PureComponent {
  render() {
    return (
      <g
        className="icon-calendar"
        stroke="none"
        strokeWidth="1"
        fill={this.props.color[0]}
        fillRule="evenodd"
      >
        <path d="M5 6v13h14V6H5zM4 4h16a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" />
        <path d="M9 6.945a1 1 0 1 1-2 0V2.948a1 1 0 0 1 2 0v3.997zm8 0a1 1 0 0 1-2 0V2.948a1 1 0 0 1 2 0v3.997zM20.004 10a1 1 0 1 1-.008 2l-16-.057a1 1 0 0 1 .007-2l16 .057z" />
      </g>
    )
  }
}

class Time extends PureComponent {
  render() {
    return (
      <g
        className="icon-time"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(-864.000000, -873.000000)">
          <g transform="translate(321.000000, 757.000000)">
            <g transform="translate(0.000000, 101.000000)">
              <g transform="translate(542.000000, 14.000000)">
                <rect x="0" y="0" width="16" height="16"></rect>
                <g
                  strokeWidth="1"
                  fillRule="evenodd"
                  transform="translate(2.000000, 2.000000)"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path
                    d="M12,6 C12,9.31371429 9.31371429,12 6,12 C2.68628571,12 0,9.31371429 0,6 C0,2.68628571 2.68628571,0 6,0 C9.31371429,0 12,2.68628571 12,6 Z"
                    stroke="#818A91"
                    strokeWidth="2"
                  ></path>
                  <path
                    d="M6,2.99739244 L6,5.99543677"
                    stroke="#818A91"
                    strokeWidth="2"
                  ></path>
                  <path
                    d="M8,7.99413299 L6,5.99543677"
                    stroke="#8C969D"
                    strokeWidth="2"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    )
  }
}

class Info extends PureComponent {
  render() {
    return (
      <g
        className="icon-info"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          fill={this.props.color[0]}
          d="M12,6c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S11.4,6,12,6z M12,10c0.6,0,1,0.4,1,1v6c0,0.6-0.4,1-1,1s-1-0.4-1-1v-6C11,10.4,11.4,10,12,10z M12,4c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S16.4,4,12,4z M12,2c5.5,0,10,4.5,10,10s-4.5,10-10,10S2,17.5,2,12S6.5,2,12,2z"
        />
      </g>
    )
  }
}

class Close extends PureComponent {
  render() {
    return (
      <g
        className="icon-close"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(-965.000000, -169.000000)">
          <g transform="translate(222.000000, 151.000000)">
            <g transform="translate(741.000000, 16.000000)">
              <rect x="0" y="0" width="16" height="16"></rect>
              <path
                d="M3,3 L13,13"
                stroke={this.props.color[0]}
                strokeWidth="2"
                strokeLinecap="round"
              ></path>
              <path
                d="M3,3 L13,13"
                stroke={this.props.color[0]}
                strokeWidth="2"
                strokeLinecap="round"
                transform="translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000) "
              ></path>
            </g>
          </g>
        </g>
      </g>
    )
  }
}

class Fail extends PureComponent {
  render() {
    return (
      <>
        <g className="icon-fail">
          <image
            width={259.2}
            height={211.03}
            xlinkHref={illustrationFail}
          ></image>
        </g>
      </>
    )
  }
}

class HomeElectricity extends PureComponent {
  render() {
    return (
      <g className="icon-home">
        <g>
          <path
            d="M36.5373 15.5111L19.509 1.18737C19.2314 0.937542 18.6761 0.937542 18.3985 1.18737L1.27763 15.5111C1.09254 15.6776 1 15.8442 1 16.0107V17.9261C1 18.3425 1.37018 18.6756 1.8329 18.6756H5.34961V31.2505C5.34961 31.6669 5.71979 32 6.18252 32H14.0488C14.5116 32 14.8817 31.6669 14.8817 31.2505C14.8817 30.8341 14.5116 30.501 14.0488 30.501H7.01542V18.0094C7.01542 17.593 6.64524 17.2599 6.18252 17.2599H2.66581V16.4271L18.9537 2.76964L35.2416 16.3439V17.1766H31.7249C31.2622 17.1766 30.892 17.5097 30.892 17.9261V30.501H19.7866V26.004C22.1928 25.6709 23.9512 23.7555 23.9512 21.5903V19.4251L24.7841 18.5091C24.8766 18.3425 24.9692 18.2592 24.9692 18.0927V16.3439C24.9692 15.9275 24.599 15.6776 24.2288 15.6776H22.9332V12.5131C22.9332 12.0967 22.563 11.8469 22.1928 11.8469C21.7301 11.8469 21.4524 12.18 21.4524 12.5131V15.6776H16.6401V12.5131C16.6401 12.0967 16.2699 11.8469 15.8997 11.8469C15.437 11.8469 15.1594 12.18 15.1594 12.5131V15.6776H13.8638C13.401 15.6776 13.1234 16.0107 13.1234 16.3439V18.0927C13.1234 18.2592 13.2159 18.4258 13.3085 18.5091L14.1414 19.4251V21.5903C14.1414 23.8388 15.8997 25.6709 18.3059 26.004V31.2505C18.3059 31.6669 18.6761 32 19.1388 32H31.8175C32.2802 32 32.6504 31.6669 32.6504 31.2505V18.7589H36.1671C36.6298 18.7589 37 18.4258 37 18.0094V16.0107C36.8149 15.8442 36.7224 15.6776 36.5373 15.5111ZM15.0668 18.5091L14.419 17.8428V17.0933H23.3959V17.8428L22.8406 18.5091H15.0668ZM15.437 21.5903V19.8415H22.3779V21.5903C22.3779 23.3392 20.8046 24.6716 18.9537 24.6716C17.1028 24.6716 15.437 23.3392 15.437 21.5903Z"
            strokeWidth="0.5"
          />
        </g>
      </g>
    )
  }
}

class Residential extends PureComponent {
  render() {
    return (
      <g className="icon-residential">
        <g>
          <rect fill="none" width="65" height="64" />
          <path
            fill={this.props.color[0]}
            stroke={this.props.color[0]}
            strokeMiterlimit="10"
            strokeWidth="0.2"
            d="M49,24.15,33.5,12.27a1.56,1.56,0,0,0-1.9,0L16.05,24.15a1.56,1.56,0,0,0-.62,1.25V49.8a2.25,2.25,0,0,0,.66,1.59,2.22,2.22,0,0,0,1.59.66H47.32a2.25,2.25,0,0,0,2.25-2.25V25.4A1.6,1.6,0,0,0,49,24.15ZM35.92,44H29.18a1.57,1.57,0,0,0-1.57,1.57v3.35H19.92a1.35,1.35,0,0,1-1.35-1.35V26.17l14-10.68L46.43,26.17V47.56a1.35,1.35,0,0,1-1.35,1.35H37.49V45.56A1.57,1.57,0,0,0,35.92,44Z"
          />
          <rect
            fill={this.props.color[0]}
            stroke={this.props.color[0]}
            strokeMiterlimit="10"
            strokeWidth="0.2"
            x="38.49"
            y="27.28"
            width="4"
            height="4"
          />
          <rect
            fill={this.props.color[0]}
            stroke={this.props.color[0]}
            strokeMiterlimit="10"
            strokeWidth="0.2"
            x="30.79"
            y="27.28"
            width="4"
            height="4"
          />
          <rect
            fill={this.props.color[0]}
            stroke={this.props.color[0]}
            strokeMiterlimit="10"
            strokeWidth="0.2"
            x="22.62"
            y="27.28"
            width="4"
            height="4"
          />
          <rect
            fill={this.props.color[0]}
            stroke={this.props.color[0]}
            strokeMiterlimit="10"
            strokeWidth="0.2"
            x="38.49"
            y="34.28"
            width="4"
            height="4"
          />
          <rect
            fill={this.props.color[0]}
            stroke={this.props.color[0]}
            strokeMiterlimit="10"
            strokeWidth="0.2"
            x="30.79"
            y="34.28"
            width="4"
            height="4"
          />
          <rect
            fill={this.props.color[0]}
            stroke={this.props.color[0]}
            strokeMiterlimit="10"
            strokeWidth="0.2"
            x="22.62"
            y="34.28"
            width="4"
            height="4"
          />
        </g>
      </g>
    )
  }
}

class ElectricitySupply extends PureComponent {
  render() {
    return (
      <g className="icon-electricity">
        <mask
          id="mask0_1432_1335"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="8"
          width="32"
          height="33"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4 15.8285L17.2981 14.1724L16.0623 24.6769L8.95018 27.8378C8.37237 28.0946 8 28.6676 8 29.2999V32.4999C8 33.3835 8.71634 34.0999 9.6 34.0999C10.4837 34.0999 11.2 33.3835 11.2 32.4999V30.3397L15.6276 28.3719L14.411 38.7129C14.3077 39.5905 14.9355 40.3856 15.8131 40.4889C16.2875 40.5447 16.7378 40.3869 17.0678 40.0914L24.0124 33.9295L30.936 40.0948C31.2656 40.3881 31.7144 40.5445 32.1871 40.4889C33.0647 40.3856 33.6924 39.5905 33.5892 38.7129L32.3726 28.372L36.8 30.3397V32.4999C36.8 33.3835 37.5163 34.0999 38.4 34.0999C39.2837 34.0999 40 33.3835 40 32.4999V29.2999C40 28.6676 39.6276 28.0946 39.0498 27.8378L31.9379 24.677L30.7021 14.1725L33.6 15.8285V18.1C33.6 18.9836 34.3163 19.6999 35.2 19.6999C36.0837 19.6999 36.8 18.9836 36.8 18.1V14.9C36.8 14.3258 36.4923 13.7957 35.9938 13.5108L27.5938 8.71081C27.3521 8.57266 27.0784 8.5 26.8 8.5H21.2C20.9216 8.5 20.6479 8.57266 20.4062 8.71081L12.0062 13.5108C11.5077 13.7957 11.2 14.3258 11.2 14.9V18.1C11.2 18.9836 11.9163 19.6999 12.8 19.6999C13.6837 19.6999 14.4 18.9836 14.4 18.1V15.8285ZM26.874 22.8999L24 19.6154L21.126 22.8999H26.874ZM20.2674 26.3098L24.0162 29.6481L27.7632 26.3234L27.2605 26.0999H20.7395L20.2674 26.3098ZM24 14.7559L21.4257 11.8138L21.6249 11.7H26.3751L26.5743 11.8138L24 14.7559ZM18.0798 34.9154L21.606 31.7866L18.7474 29.2411L18.0798 34.9154ZM26.4226 31.7909L29.9191 34.9044L29.2569 29.2761L26.4226 31.7909ZM21.874 17.1857L20.3681 15.4647L19.9003 19.4413L21.874 17.1857ZM26.126 17.1857L28.0999 19.4415L27.632 15.4646L26.126 17.1857Z"
            fill="#818A91"
          />
        </mask>
        <g mask="url(#mask0_1432_1335)">
          <rect
            width="48"
            height="48"
            transform="translate(0 0.5)"
            fill="#00B0B2"
          />
        </g>
      </g>
    )
  }
}

class CardPayment extends PureComponent {
  render() {
    return (
      <g className="icon-card-payment">
        <mask
          id="mask0_1432_1344"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="6"
          y="10"
          width="36"
          height="29"
        >
          <path
            d="M14 28.5C12.8954 28.5 12 29.3954 12 30.5C12 31.6046 12.8954 32.5 14 32.5H24C25.1046 32.5 26 31.6046 26 30.5C26 29.3954 25.1046 28.5 24 28.5H14Z"
            fill="#818A91"
          />
          <path
            d="M28 30.5C28 29.3954 28.8954 28.5 30 28.5H34C35.1046 28.5 36 29.3954 36 30.5C36 31.6046 35.1046 32.5 34 32.5H30C28.8954 32.5 28 31.6046 28 30.5Z"
            fill="#818A91"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 10.5C7.79086 10.5 6 12.2909 6 14.5V34.5C6 36.7091 7.79086 38.5 10 38.5H38C40.2091 38.5 42 36.7091 42 34.5V14.5C42 12.2909 40.2091 10.5 38 10.5H10ZM38 18.5V14.5H10V18.5H38ZM10 22.5H38V34.5H10V22.5Z"
            fill="#818A91"
          />
        </mask>
        <g mask="url(#mask0_1432_1344)">
          <rect
            width="48"
            height="48"
            transform="translate(0 0.5)"
            fill="#00B0B2"
          />
        </g>
      </g>
    )
  }
}

class Commercial extends PureComponent {
  render() {
    return (
      <>
        <g className="icon-commercial">
          <g>
            <path
              className="icon-commercial_cls-1"
              fill={this.props.color[0]}
              d="M30,39.68a.87.87,0,0,0,.87.87H45.93a.87.87,0,0,0,0-1.74h-15A.87.87,0,0,0,30,39.68Z"
            />
            <path
              className="icon-commercial_cls-1"
              fill={this.props.color[0]}
              d="M45.93,43.53h-15a.87.87,0,0,0,0,1.74H45.93a.87.87,0,0,0,0-1.74Z"
            />
            <path
              className="icon-commercial_cls-1"
              fill={this.props.color[0]}
              d="M53.2,24a1.75,1.75,0,0,0-1.78.05L44.8,28.24V25.5A1.75,1.75,0,0,0,42.12,24L35.5,28.24V25.5A1.75,1.75,0,0,0,32.82,24L24,29.67h-.23L22.65,13.58A1.74,1.74,0,0,0,20.91,12H16.19a1.74,1.74,0,0,0-1.74,1.63L13.38,29.67h-.74a1.74,1.74,0,0,0-1.74,1.74v18.9a1.74,1.74,0,0,0,1.74,1.74H52.36a1.74,1.74,0,0,0,1.74-1.74V25.5A1.74,1.74,0,0,0,53.2,24ZM19.28,15.43,19.52,19H17.58l.23-3.59ZM17.34,22.5h2.41l.48,7.17H16.87Zm-3,10.65h8.33V48.57H14.38ZM50.62,48.57H26.2V32.37L32,28.67v2.74a1.74,1.74,0,0,0,2.68,1.47l6.62-4.21v2.74A1.74,1.74,0,0,0,44,32.88l6.63-4.21Z"
            />
            <rect
              className="icon-commercial_cls-2"
              fill="none"
              width="65"
              height="64"
            />
          </g>
        </g>
      </>
    )
  }
}

export default {
  chevRight: Icon(ChevArrowRight, {
    viewBox: '0 0 24 24',
    color: ['#8c969d'],
  }),
  chevLeft: Icon(ChevArrowLeft, {
    viewBox: '0 0 24 24',
    color: ['#8c969d'],
  }),
  spinloader: Icon(SpinLoader, {
    viewBox: '0 0 100 100',
    color: ['#ffffff'],
  }),
  success: Icon(Success, {
    viewBox: '0 0 204 153',
    color: [
      '#52CFD1',
      '#06B2B4',
      '#00B0B2',
      '#FFFFFF',
      '#EBF0F5',
      '#F8FCFF',
      '#FACBBD',
      '#3176DE',
      '#266396',
      '#FFCBBB',
      '#CED5DC',
      '#979797',
      '#D8D8D8',
    ],
  }),
  emptyList: Icon(EmptyList, {
    viewBox: '0 0 40 47',
    color: ['#CED5DC', '#F3F6F7', '#BEC8CE'],
  }),
  leave: Icon(Leave, {
    viewBox: '0 0 96.93 123.49',
    color: ['#a0a9ad'],
  }),
  clock: Icon(Clock, {
    viewBox: '0 0 104.51 112.79',
    color: ['#a1aaad'],
  }),
  globe: Icon(Globe, {
    viewBox: '0 0 128.17 129.19',
    color: ['#a1aaad'],
  }),
  notice: Icon(Notice, {
    viewBox: '0 0 43 40',
    color: ['#979797'],
  }),
  calendar: Icon(Calendar, {
    viewBox: '0 0 24 24',
    color: ['#8c969d'],
  }),
  time: Icon(Time, {
    viewBox: '0 0 14 14',
    color: ['#818A91'],
  }),
  info: Icon(Info, {
    viewBox: '0 0 24 24',
    color: ['#818A91'],
  }),
  close: Icon(Close, {
    viewBox: '0 0 12 12',
    color: ['#8C969D'],
  }),
  fail: Icon(Fail, {
    viewBox: '0 0 259.2 210.99',
    color: ['#8C969D'],
  }),
  homeElectricity: Icon(HomeElectricity, {
    viewBox: '0 0 38 33',
    color: ['#4f5a60'],
  }),
  residential: Icon(Residential, {
    viewBox: '0 0 65 64',
    color: ['#4f5a60'],
  }),
  commercial: Icon(Commercial, {
    viewBox: '0 0 65 64',
    color: ['#4f5a60'],
  }),
  electricity: Icon(ElectricitySupply, {
    viewBox: '0 0 48 48',
    color: ['#4f5a60'],
  }),
  cardPayment: Icon(CardPayment, {
    viewBox: '0 0 48 48',
    color: ['#4f5a60'],
  }),
}
